import { keys, prop } from "ramda";

export const getQuestions = apiQuestions => {
  const parents = getParents(apiQuestions);
  const ids = keys(parents);

  return ids.map(id => ({
    ...parents[id],
    questions: apiQuestions.filter(
      ({ question: { parent } }) => parent.id === parseInt(id, 10)
    )
  }));
};

export const getParents = apiQuestions =>
  apiQuestions.reduce(
    (acc, { question: { parent } }) => ({ ...acc, [parent.id]: parent }),
    {}
  );

export const getQuestionsIds = apiQuestions => apiQuestions.map(prop("id"));

export const formDataToResponse = ({ shared, general, ...data }) => ({
  general_feedback: general,
  shared: true,
  responses: keys(data).map(id => ({
    id: +id,
    response_content: +data[id]
  }))
});



// WEBPACK FOOTER //
// ./src/modules/feedback/model.js